import React, { useContext } from "react";
import CarContext from "../../context/CarContext";
import Expanding from "./Expanding";
import { priceFormatter } from '../../../helpers/Numbers';

const Warranty = ()=> {
    const { car } = useContext(CarContext)

    const warranties = car.warranties || false

    if ( ! warranties || ! warranties.length ) {
        return(<></>)
    }
    return(
        <>  
            <div className='section warranties'>
                <h2 className="section-title">Garanti{ warranties.length > 1 ? 'er':'' }</h2>
                <Expanding label="Visa mer" label_expanded="Visa mindre" tall="true">
                <div className="warranties-wrapper">
                    { warranties.map( ({id, title, description, is_optional, price, link},i) => {
                        return(
                            <div key={id} className={ is_optional ?  'warranty optional' :'warranty'}>
                                <h3>{title}</h3>
                                <p>{description}</p>
                                <div className="warranty-details">
                                    <a rel="noopener noreferrer" target={'_blank'} className="warranty-link" href={link}>Omfattning och fullständiga villkor</a>
                                    <span className="warranty-price">
                                        Pris  
                                        <span className="box"> {
                                            price !== null 
                                                ? priceFormatter(price) 
                                                : 'Ingår' 
                                        }</span>
                                    </span>
                                </div>
                            </div>
                        ) 
                    })}
                </div>  
                </Expanding>
            </div>
        </>
    )

}

export default Warranty